import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from '@/components/ui/sidebar'
import { Skeleton } from '@/components/ui/skeleton'

export function SidebarTenantSelectSkeleton() {
	return (
		<SidebarGroup className="p-0">
			<SidebarGroupLabel>Organization</SidebarGroupLabel>
			<SidebarMenu>
				<SidebarMenuItem>
					<SidebarMenuButton
						size="lg"
						className="data-[state=open]:text-sidebar-accent-foreground bg-accent/20 hover:text-sidebar-accent-foreground hover:bg-accent/50 dark:bg-background dark:hover:bg-accent"
						render={<Skeleton className="h-8 w-full" />}
					></SidebarMenuButton>
				</SidebarMenuItem>
			</SidebarMenu>
		</SidebarGroup>
	)
}
